import { RegionId } from '../region-id.enum';
import { StripeProductType } from '../stripe-product-type';
import { QCChecklistTemplateBody } from './qc-checklist-template-body.model';

/**
 * Detail returned by GET /api/qc-checklist-templates/{id}.
 */
export interface QCChecklistTemplateDetail {
    readonly id: number;
    readonly name: string;
    readonly isActive: boolean;
    readonly treatmentTypeOriginalId?: number | null;
    readonly treatmentSubTypeOriginalId?: number | null;
    readonly organizationId?: string | null;
    readonly officeId?: string | null;
    readonly region?: RegionId | null;
    readonly stripeProductType?: StripeProductType | null;
    readonly body: QCChecklistTemplateBody;
    readonly createdDate: string;
    readonly modifiedDate: string;
    readonly createdBy?: string | null;
    readonly modifiedBy?: string | null;
}
